<script>
import ModalCourseSectionComponent from '../../features/modals/ModalCourseSectionComponent';
import ModalCourseSubjectView from './ModalCourseSubjectView';
import draggable from 'vuedraggable';

export default {
  name: 'ModalCourseSectionView',
  components: {
    'modal-course-subject-view': ModalCourseSubjectView,
    draggable,
  },
  extends: ModalCourseSectionComponent,
};
</script>

<template>
  <div>
    <el-dialog
      v-model="conf.isVisible"
      title="Sección"
      width="60%"
      class="course-section-modal"
      append-to-body
      :before-close="onCancel"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        v-loading="conf.isLoading"
        :model="formData"
        :rules="rules"
        status-icon
        :label-position="'top'"
      >
        <fieldset>
          <legend>Información de Sección</legend>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="18"
              :md="18"
              :lg="20"
              :xl="20"
            >
              <el-form-item
                label="Título"
                prop="title"
              >
                <el-input
                  v-model="formData.title"
                  maxlength="120"
                  size="small"
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="6"
              :md="6"
              :lg="4"
              :xl="4"
            >
              <el-form-item
                label="Orden"
                prop="sort"
              >
                <el-input-number
                  v-model="formData.sort"
                  size="small"
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <el-form-item
                label="Descripción"
                prop="description"
              >
                <el-input
                  v-model="formData.description"
                  type="textarea"
                  :row="3"
                  maxlength="255"
                  size="small"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="4"
              :md="4"
              :lg="4"
              :xl="4"
              align="center"
            >
              <el-form-item
                label="Especialidad"
                prop="career"
              >
                <el-switch
                  v-model="formData.isSpecialty"
                  active-text="SI"
                  inactive-text="NO"
                  @change="onChangeIsSpecialty"
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="10"
              :md="10"
              :lg="10"
              :xl="10"
            >
              <el-form-item
                label="Especialidad"
                prop="career"
              >
                <el-select
                  v-model="formData.specialties"
                  multiple
                  filterable
                  clearable
                  placeholder="Seleccionar"
                  value-key="id"
                  size="small"
                  :disabled="!formData.isSpecialty"
                  @change="onChangeSpecialties"
                  @remove-tag="onChangeRemoveSpecialties"
                >
                  <el-option
                    v-for="item in careers"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="course-section-header">
            <div class="title-icon">
              <h3 class="title">
                <i class="uil uil-book-open" /> Temas de la Sección
              </h3>
            </div>
            <el-button
              type="primary"
              size="small"
              class="btn-primary"
              icon="el-icon-circle-plus"
              :disabled="!onCanCreateCourseSubject(modulePermissions)"
              @click="onCreateCourseSubject"
            >
              Agregar Tema
            </el-button>
          </div>

          <div class="course-sections-wrapper">
                <div
                  v-if="!hasVisibleCourseSubjects()"
                  class="course-sections-empty"
                >
                  <el-empty
                    :image-size="60"
                    description="No hay temas agregados en esta sección."
                  >
                    <el-button
                      type="primary"
                      size="small"
                      class="btn-primary"
                      icon="el-icon-circle-plus"
                      :disabled="!onCanCreateCourseSubject(modulePermissions)"
                      @click="onCreateCourseSubject"
                    >
                      Agregar Primer Tema
                    </el-button>
                  </el-empty>
                </div>
                <div
                  v-else
                  class="course-sections-table"
                >
                  <div class="sections-table-head">
                    <div class="th-col col-sort">ORDEN</div>
                    <div class="th-col col-title">TÍTULO</div>
                    <div class="th-col col-topics">ACTIVIDADES</div>
                    <div class="th-col col-actions">OPCIONES</div>
                  </div>
                  <draggable
                    v-model="formData.courseSubjects"
                    item-key="sort"
                    handle=".drag-handle"
                    ghost-class="ghost-section-row"
                    @change="onChangeDrag"
                  >
                    <template #item="{ element, index }">
                      <div
                        v-show="element.updateState !== formData.UPDATE_STATUS.REMOVED"
                        :key="element.sort || index"
                        class="sections-table-row"
                      >
                        <!-- Orden / Drag Handle -->
                        <div class="td-col col-sort">
                          <i
                            class="fa fa-grip-vertical drag-handle"
                            title="Arrastrar para ordenar"
                          />
                          <span class="order-badge">{{ element.sort }}</span>
                        </div>

                        <!-- Título -->
                        <div class="td-col col-title">
                          <span class="section-title-text">{{ element.title }}</span>
                        </div>

                        <!-- Actividades -->
                        <div class="td-col col-topics">
                          <el-tag
                            size="small"
                            type="primary"
                            effect="plain"
                          >
                            <i class="fa fa-tasks" />
                            {{ element.getTotalActivities ? element.getTotalActivities() : 0 }} actividades
                          </el-tag>
                        </div>

                        <!-- Opciones -->
                        <div class="td-col col-actions">
                          <el-dropdown
                            trigger="click"
                            @command="onChangeItemOptions"
                          >
                            <el-button
                              size="small"
                              class="btn-row-action"
                            >
                              <i class="fa fa-ellipsis-v" />
                            </el-button>
                            <template #dropdown>
                              <el-dropdown-menu>
                                <el-dropdown-item
                                  :command="{
                                    command: 'edit',
                                    item: element,
                                    index: index,
                                  }"
                                  :disabled="
                                    !onCanReadCourseSubject(modulePermissions)
                                  "
                                >
                                  <i class="el-icon-edit" />
                                  Mostrar
                                </el-dropdown-item>
                                <el-dropdown-item
                                  :command="{
                                    command: 'delete',
                                    item: element,
                                    index: index,
                                  }"
                                  :disabled="
                                    !onCanDeleteCourseSubject(modulePermissions)
                                  "
                                  divided
                                >
                                  <i class="el-icon-delete" />
                                  Eliminar
                                </el-dropdown-item>
                              </el-dropdown-menu>
                            </template>
                          </el-dropdown>
                        </div>
                      </div>
                    </template>
                  </draggable>
                </div>
              </div>
        </fieldset>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            size="small"
            class="btn-cancel"
            @click="onCancel"
          >Cancelar</el-button>
          <el-button
            type="primary"
            :disabled="!onCanSaveOrUpdate()"
            class="btn-primary"
            size="small"
            @click="onSubmitForm('formData')"
          >Aceptar</el-button>
        </span>
      </template>
    </el-dialog>
    <modal-course-subject-view
      v-if="modalItemCourseSubject.isVisible"
      :form-data="itemCourseSubject"
      :conf="modalItemCourseSubject"
    />
  </div>
</template>
